/**
 * CalculateListContainer
 * --
 */
import React from 'react';
import CalculateListPresenter from './CalculateListPresenter';

const CalculateListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CalculateListPresenter />
    </>
  );
};

export default CalculateListContainer;
